"use client";

import styled from "styled-components";

export const List = styled.ul`
  padding: 0;
  margin: 0;
`;

export const BoxColor = styled.span`
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background: var(--green);
`;

export const ListItem = styled.li`
  font-family: "Inter Normal";
  font-size: 14px;
  color: 13px;
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
  width: 100%;
  gap: 10px;

  &:nth-child(2) {
    span {
      background: var(--blue);
    }
  }

  &:nth-child(3) {
    span {
      background: var(--yellow);
    }
  }
`;
